
import { defineComponent } from 'vue'
import useMaintenanceStatus from '@/Hooks/useMaintenanceStatus'

export default defineComponent({
  name: 'MaintenancePage',
  setup() {
    const { fetchMaintenanceStatus, title, message } = useMaintenanceStatus()
    fetchMaintenanceStatus()

    return {
      title,
      message,
    }
  },
  components: {},
})
